import { Grid } from "@mui/material";
import { PageHeader } from "../../../../components/PageHeader";
import { useTranslation } from "react-i18next";
import NumberBox from "../../../../components/NumberBox";
import StarRateIcon from "@mui/icons-material/StarRate";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssistantPhotoIcon from "@mui/icons-material/AssistantPhoto";
import StarIcon from "@mui/icons-material/Star";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import BrowseGalleryIcon from "@mui/icons-material/BrowseGallery";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { campaignDetail, followCampaign } from "../../../../api/specialization/KeywordSpecializationAPI";

export function KeywordCampaignDetailPage() {
  const { t } = useTranslation(["common", "keyword", "author"]);
  const { id } = useParams();
  const [data, setPageData] = useState(null);
  useEffect(() => {
    // campaignDetail(parseInt(id)).then((res) => {
    //   console.log(res);
    //   setPageData(res);
    // });
  }, []);
  return (
    <Grid container>
      <PageHeader text={t("keyword:campaign_detail")} />
      <Grid container xs={12}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={3.25} className="grid-border white">
          <NumberBox
            title={t("keyword:main")}
            variant={"h3"}
            number={"Palestine"}
            icon={
              <StarRateIcon
                color="warning"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.5} className="grid-border white">
          <NumberBox
            title={t("keyword:average_headline_time")}
            variant={"h3"}
            number={Math.round(100) + " " + t("common:minutes")}
            icon={
              <BrowseGalleryIcon
                sx={{ width: "40px", height: "40px", color: "#81d4fa" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid item xs={3.25} className="grid-border white">
          <NumberBox
            title={t("keyword:appearances_week")}
            variant={"h3"}
            number={Math.round(100)}
            icon={
              <AutoGraphIcon
                color="success"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>

      <Grid container xs={12} marginTop={2}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={3.25} className="grid-border white">
          <NumberBox
            title={t("keyword:no_of_distinct_sources")}
            variant={"h3"}
            number={Math.round(100)}
            icon={
              <AutoGraphIcon
                color="success"
                sx={{ width: "40px", height: "40px" }}
              />
            }
            subtitle={t("common:derived_from_this_week")}
          />
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
    </Grid>
  );
}
